const Features = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Our Core Features
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Tally Technologies Limited delivers innovative, secure, and scalable
            technology solutions designed to help businesses grow and operate
            efficiently in a digital-first world.
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {/* Feature 1 */}
          <div className="p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Scalable Digital Solutions
            </h3>
            <p className="text-gray-600">
              We build flexible and scalable platforms that grow with your
              business, from startups to enterprise-level organizations.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Secure & Reliable Systems
            </h3>
            <p className="text-gray-600">
              Security is at the core of everything we do. Our systems are
              designed with industry-standard security practices to protect
              your data and operations.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Custom Business Solutions
            </h3>
            <p className="text-gray-600">
              We tailor software solutions to meet your unique business needs,
              ensuring efficiency, automation, and measurable results.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Technology Consulting
            </h3>
            <p className="text-gray-600">
              Our experts provide strategic guidance to help you choose the
              right technologies and optimize your digital transformation
              journey.
            </p>
          </div>

          {/* Feature 5 */}
          <div className="p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Seamless Integration
            </h3>
            <p className="text-gray-600">
              We integrate seamlessly with existing systems, APIs, and
              third-party platforms to ensure smooth operations and continuity.
            </p>
          </div>

          {/* Feature 6 */}
          <div className="p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition">
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Ongoing Support & Growth
            </h3>
            <p className="text-gray-600">
              Our partnership doesn’t end at deployment. We provide continuous
              support, updates, and optimization to help your business scale.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
